import { render, staticRenderFns } from "./ViewContact.vue?vue&type=template&id=75ca094a&scoped=true"
import script from "./ViewContact.vue?vue&type=script&lang=js"
export * from "./ViewContact.vue?vue&type=script&lang=js"
import style0 from "./ViewContact.vue?vue&type=style&index=0&id=75ca094a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ca094a",
  null
  
)

export default component.exports